import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16.066 16.066",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.066 16.066\" id=\"icon-search\"><path d=\"M6.166,12.244a6.122,6.122,0,1,1,6.166-6.122A6.151,6.151,0,0,1,6.166,12.244Zm0-10.153a4.031,4.031,0,1,0,4.061,4.031A4.05,4.05,0,0,0,6.166,2.091Zm6.246,8.33a7.639,7.639,0,0,1-2.054,2l3.676,3.65,2.032-2.017L12.412,10.42Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol